import { Controller } from 'react-hook-form'
import SuggestionField from "../../prestataires/SuggestionField"
import { Select, Textarea } from '@/components/ui'
import { useInterventionForm } from './InterventionFormContext'

export default () => {
  const { control, intervention, entiteFacturableOptions, 
    handleNewPrestataire, hasError, getErrorMessage 
  } = useInterventionForm()
 
  return (
    <div className="grid grid-cols-2 gap-2 p-4">
      <div className='flex flex-col items-center space-y-4'>
        <div className='w-2/3'>
          <Controller 
            name='prestataire'
            control={control}
            className=''
            render={({field}) => (
              <SuggestionField
                prestataireField={field}
                originalData={intervention.prestataire}
                label='Prestataire'
                onNewPrestataire={handleNewPrestataire}
                validator={{hasError, getErrorMessage}}
              />
            )}
          />
        </div>

        <Select.Form name='entite_facturable'
          control={control}
          label='Entité à facturer'
          options={entiteFacturableOptions}
          validator={{hasError, getErrorMessage}}
          className='w-2/3'
        />
      </div>

      <div className='flex space-x-4 w-2/3'>
        <Textarea.Form name='details'
          label="Détails de l'intervention"
          control={control}
          validator={{hasError, getErrorMessage}}
        />
      </div>
    </div>
  )
}